// Lightweight Meta (Facebook) Pixel helper.
// Connected to Meta Pixel ID 2832673310418578.

const PIXEL_ID = '2832673310418578'

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: unknown
  }
}

let initialized = false

/**
 * Injects the Meta Pixel base code and fires the initial PageView.
 * Safe to call multiple times — it only initializes once.
 */
export function initPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  if (!PIXEL_ID || PIXEL_ID === 'YOUR_PIXEL_ID') {
    // No real pixel configured yet — no-op so the page still works.
    initialized = true
    return
  }

  // The Meta Pixel loads a third-party script from connect.facebook.net.
  // In sandboxed previews or behind ad blockers that request can fail and
  // throw an opaque cross-origin "Script error." — wrap everything so a
  // failing pixel can never crash the app.
  try {
    /* eslint-disable */
    ;(function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return
      const n: any = (f.fbq = function () {
        try {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments)
        } catch {
          /* swallow pixel errors */
        }
      })
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      const t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = v
      // Never let a failed third-party load bubble up as an app error.
      t.onerror = () => {}
      const s = b.getElementsByTagName(e)[0]
      s.parentNode?.insertBefore(t, s)
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )
    /* eslint-enable */

    window.fbq?.('init', PIXEL_ID)
    window.fbq?.('track', 'PageView')
  } catch {
    // Ignore — analytics must never break the page.
  } finally {
    initialized = true
  }
}

/**
 * Tracks a standard Meta Pixel event.
 * No-ops gracefully when the pixel isn't configured.
 */
export function trackPixel(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined') return
  try {
    if (window.fbq) {
      window.fbq('track', event, params)
    }
  } catch {
    // Ignore — analytics must never break the page.
  }
}
